import { JuloUpdateEntry } from "./types"

export const atgarderHeterAttGoraEntry: JuloUpdateEntry = {
  slug: "2026-06-23-atgarder-heter-att-gora",
  date: "2026-06-23",
  title: 'Fliken "Åtgärder" heter nu "Att göra"',
  description:
    'På jobbsidan heter sektionen som tidigare hette "Åtgärder" nu "Att göra". Det är exakt samma innehåll och funktion som förut — ni bockar av era uppgifter på precis samma sätt — men namnet är tydligare för checklistan ni arbetar i.',
}
